module.exports = __webpack_public_path__ + "static/jon-stewart-182b617f4b71cf34d8f6690109205c91.jpg";